const getProfile = (base64) => {
  return {
    type: "profileImg",
    base64,
  };
};

export default getProfile;
